"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bignumber_js_1 = require("bignumber.js");

var Ar =
/*#__PURE__*/
function () {
  function Ar() {
    _classCallCheck(this, Ar);

    // Configure and assign the constructor function for the bignumber library.
    this.BigNum = function (value, decimals) {
      var instance = bignumber_js_1.BigNumber.clone({
        DECIMAL_PLACES: decimals
      });
      return new instance(value);
    };
  }

  _createClass(Ar, [{
    key: "winstonToAr",
    value: function winstonToAr(winstonString) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$formatted = _ref.formatted,
          formatted = _ref$formatted === void 0 ? false : _ref$formatted,
          _ref$decimals = _ref.decimals,
          decimals = _ref$decimals === void 0 ? 12 : _ref$decimals,
          _ref$trim = _ref.trim,
          trim = _ref$trim === void 0 ? true : _ref$trim;

      var number = this.stringToBigNum(winstonString, decimals).shiftedBy(-12);
      return formatted ? number.toFormat(decimals) : number.toFixed(decimals);
    }
  }, {
    key: "arToWinston",
    value: function arToWinston(arString) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$formatted = _ref2.formatted,
          formatted = _ref2$formatted === void 0 ? false : _ref2$formatted;

      var number = this.stringToBigNum(arString).shiftedBy(12);
      return formatted ? number.toFormat() : number.toFixed(0);
    }
  }, {
    key: "compare",
    value: function compare(winstonStringA, winstonStringB) {
      var a = this.stringToBigNum(winstonStringA);
      var b = this.stringToBigNum(winstonStringB);
      return a.comparedTo(b);
    }
  }, {
    key: "isEqual",
    value: function isEqual(winstonStringA, winstonStringB) {
      return this.compare(winstonStringA, winstonStringB) === 0;
    }
  }, {
    key: "isLessThan",
    value: function isLessThan(winstonStringA, winstonStringB) {
      var a = this.stringToBigNum(winstonStringA);
      var b = this.stringToBigNum(winstonStringB);
      return a.isLessThan(b);
    }
  }, {
    key: "isGreaterThan",
    value: function isGreaterThan(winstonStringA, winstonStringB) {
      var a = this.stringToBigNum(winstonStringA);
      var b = this.stringToBigNum(winstonStringB);
      return a.isGreaterThan(b);
    }
  }, {
    key: "add",
    value: function add(winstonStringA, winstonStringB) {
      var a = this.stringToBigNum(winstonStringA);
      var b = this.stringToBigNum(winstonStringB);
      return a.plus(winstonStringB).toFixed(0);
    }
  }, {
    key: "sub",
    value: function sub(winstonStringA, winstonStringB) {
      var a = this.stringToBigNum(winstonStringA);
      var b = this.stringToBigNum(winstonStringB);
      return a.minus(winstonStringB).toFixed(0);
    }
  }, {
    key: "stringToBigNum",
    value: function stringToBigNum(stringValue) {
      var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
      return this.BigNum(stringValue, decimalPlaces);
    }
  }]);

  return Ar;
}();

exports.default = Ar;